import dayjs from "dayjs";
export default (time, format) =>
  time ? dayjs(time).format(format || "YYYY-MM-DD HH:mm:ss") : "";
